import { type LinearConfiguratorState } from "../redux/types";
import { type LinearConfiguration } from "../models";
import { prepareCommonLinearData, sendLinear } from "./sendLinearCommon";
import { prepareApiDataForUpdate } from "../../common/commonConfiguratorApi";
import { type KmatType } from "~/Configurators/Linear/kmatType";

export type CsticUpdate = {
  key: string;
  type: KmatType;
  index?: number;
  value: string | null;
};

export function sendLinearUpdate(
  linearState: LinearConfiguratorState,
  updatedCstics: CsticUpdate[],
): Promise<LinearConfiguration> {
  const data = prepareCommonLinearData(linearState);

  const updateData = prepareApiDataForUpdate(linearState, updatedCstics);

  return sendLinear({
    ...data,
    ...updateData,
  });
}
